import { useState } from "react";
import { Modal } from "react-bootstrap";
import { faDownload, faXmark, faFileInvoiceDollar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ConnectedFiles from "../../../../layout/Documents/ConnectedFiles";
import FilePreviewPanel from "../../../../layout/Documents/FilePreviewPanel";

const BillView = ({ show, setShow, children, bill, direction, extraFooter }) => {
  const [filePreview, setFilePreview] = useState(null);

  const billNumber = bill?.rechnungs_nummer || "";
  const billType = bill?.typ || "Bill";
  const title = billNumber ? `${billType} · ${billNumber}` : billType;
  const isIncoming = direction === "in";
  const headerGradient = isIncoming
    ? "linear-gradient(135deg, #c62828 0%, #7f0000 100%)"
    : "linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%)";
  const accentColor = isIncoming ? "#c62828" : "#2e7d32";
  const accentShadow = isIncoming ? "rgba(198,40,40,0.25)" : "rgba(46,125,50,0.25)";

  const handleClose = () => {
    setFilePreview(null);
    setShow(false);
  };

  return (
    <>
      <style>{`
        .bill-view-modal {
          border-radius: 14px !important;
          overflow: hidden !important;
          border: none !important;
          box-shadow: 0 8px 40px rgba(0,0,0,0.18) !important;
        }
        .modal-bill-wide { max-width: min(95vw, 1300px) !important; }
        .modal-90w { max-width: min(95vw, 900px) !important; }
      `}</style>
      <Modal
        size="xl"
        show={show}
        onHide={handleClose}
        dialogClassName={filePreview ? "modal-bill-wide" : "modal-90w"}
        contentClassName="bill-view-modal"
      >
        <Modal.Header style={{
          background: headerGradient, border: "none", padding: "20px 24px",
          display: "flex", alignItems: "center", justifyContent: "space-between",
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div style={{
              width: "36px", height: "36px", borderRadius: "8px",
              background: "rgba(255,255,255,0.2)", display: "flex",
              alignItems: "center", justifyContent: "center", fontSize: "1rem", color: "#fff",
            }}>
              <FontAwesomeIcon icon={faFileInvoiceDollar} />
            </div>
            <span style={{ fontWeight: 700, fontSize: "1.1rem", color: "#fff" }}>{title}</span>
          </div>
          <button onClick={handleClose} style={{
            background: "rgba(255,255,255,0.15)", border: "none", borderRadius: "8px",
            width: "32px", height: "32px", display: "flex", alignItems: "center",
            justifyContent: "center", cursor: "pointer", color: "#fff", fontSize: "1rem",
          }}>
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </Modal.Header>

        <Modal.Body style={{ background: "#f8f9fb", padding: "24px" }}>
          <div style={{ display: "flex", gap: "0", minHeight: 0, alignItems: "stretch" }}>
            {/* Main content */}
            <div style={{ flex: 1, minWidth: 0 }}>
              {children}
              <ConnectedFiles
                entity={bill}
                show={true}
                endpointAll="/document/finance/"
                endpointUnlink="/document/finance/"
                onFileSelect={setFilePreview}
                selectedFileId={filePreview?.id}
              />
            </div>

            {/* File preview panel */}
            {filePreview && (
              <FilePreviewPanel
                attachment={filePreview}
                onClose={() => setFilePreview(null)}
              />
            )}
          </div>
        </Modal.Body>

        <Modal.Footer style={{
          background: "#fff", borderTop: "1px solid #f0f0f0",
          padding: "14px 24px", display: "flex", gap: "8px", justifyContent: "flex-end",
        }}>
          {extraFooter}
          <button style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            padding: "8px 16px", background: accentColor, color: "#fff",
            border: "none", borderRadius: "8px", fontWeight: 600,
            fontSize: "0.88rem", cursor: "pointer",
            boxShadow: `0 2px 8px ${accentShadow}`,
          }}>
            <FontAwesomeIcon icon={faDownload} /> Generate PDF
          </button>
          <button onClick={handleClose} style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            padding: "8px 16px", background: "#f5f5f5", color: "#424242",
            border: "none", borderRadius: "8px", fontWeight: 600,
            fontSize: "0.88rem", cursor: "pointer",
          }}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BillView;
